<template>
    <Modal v-model="isShow" :title="'编辑数据集:'+(datasetInfo&&datasetInfo.name)" @on-ok="onOk" width="80%">
        <component ref="datasetEditor" v-if="datasetEditor" :is="datasetEditor" :handler="datasetHandler" :config="datasetConfig"></component>
    </Modal>
</template>
<script>
import * as extlibApi from '@/web/api/extlib';
import * as datasetApi from '@/web/api/dataset';
import * as orginLib from '@/editor-components/lib-config/index';
import {normalizeUrl} from '@/web/lib/utils'
export default {
    props:["datasetId"],
    data() {
        return {
            isShow:false,
            datasetInfo:null,
            extlib:null,
            loadedLib:null,
            datasetEditor:null,
            datasetHandler:null,
        }
    },

    computed:{
        datasetConfig(){
            try {
                return JSON.parse(this.datasetInfo.config);
            } catch (error) {
                return null;
            }
        }
    },

    watch: {

    },

    methods: {
        show(){
            this.isShow = true;
            datasetApi.loadDataset(this.datasetId).then((datasetInfo)=>{
                this.datasetInfo = datasetInfo;
            }).then(()=>{
                if(this.datasetInfo&&this.datasetInfo.type&&this.datasetInfo.type.indexOf('/')>0){
                    let index = this.datasetInfo.type.indexOf('/');
                    let prefix = this.datasetInfo.type.substring(0, index);
                    let datasetType = this.datasetInfo.type.substring(index+1);
                    this.getExtlibAndLoad(prefix, datasetType);
                }else if(this.datasetInfo&&this.datasetInfo.type){
                    let datasetType = orginLib.datasets.find((datasetType)=>{
                        return datasetType.name === this.datasetInfo.type;
                    });
                    if(datasetType){
                        this.datasetHandler = datasetType.handler;
                        this.datasetEditor = datasetType.editor;
                    }
                }
            })
        },

        onOk(){
            if(this.$refs.datasetEditor&&this.$refs.datasetEditor.update){
                this.$refs.datasetEditor.update().then((config)=>{
                    this.datasetInfo.config = JSON.stringify(config);
                    this.$emit('on-ok', this.datasetInfo);
                });
            }
            
        },

        getExtlibAndLoad(prefix, datasetType){
            return extlibApi.loadExtlibByPrefix(prefix).then((lib)=>{
                return this.extlib = lib;
            }).then((lib)=>{
                return this.importLib(`${normalizeUrl(lib.path)}${lib.entryFileName}`).then((loadedLib)=>{
                    return this.loadedLib = loadedLib;
                })
            }).then((loadedLib)=>{
                let datasetType = loadedLib.datasets.find((dataset)=>{
                    return dataset.name===datasetType;
                });

                this.datasetEditor =  datasetType.editor;
                this.datasetHandler =  datasetType.handler;
            });;
        },

        importLib(entryFilePath){
            return new Promise((r,rj)=>{
                let lib = window.System.get(entryFilePath);
                if(lib){
                    r(lib.default);
                }else{
                    window.System.import(entryFilePath).then((lib,a,b,c)=>{
                    r(lib.default);
                    }).catch(e=>{
                        rj('加载库出错，请检查...');
                    });
                }
            })
        },

        newConfigChanged(val){
            this.newConfig = val;
        }
    },
}
</script>